
    import React from 'react';
    import { dynamic } from 'dumi';
    import { Link, AnchorLink } from 'dumi/theme';
    import API from 'dumi-theme-default/es/builtins/API.js';
import Alert from 'dumi-theme-default/es/builtins/Alert.js';
import Badge from 'dumi-theme-default/es/builtins/Badge.js';
import Example from 'dumi-theme-default/es/builtins/Example.js';
import Previewer from 'dumi-theme-default/es/builtins/Previewer.js';
import SourceCode from 'dumi-theme-default/es/builtins/SourceCode.js';
    import DUMI_ALL_DEMOS from '@@/dumi/demos';

    const DumiDemo1 = React.memo(DUMI_ALL_DEMOS['table-demo'].component);

    export default (props) => {
      // scroll to anchor after page component loaded
      React.useEffect(() => {
        if (props?.location?.hash) {
          AnchorLink.scrollToAnchor(decodeURIComponent(props.location.hash.slice(1)));
        }
      }, []);

      return (
        <>
          
          <React.Fragment><div className="markdown"><h2 id="table"><AnchorLink to="#table" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Table</h2>
<p>Table</p>
<h3 id="何时使用"><AnchorLink to="#何时使用" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>何时使用</h3>
<ul>
<li>需要展示 Table</li>
</ul>
<h3 id="代码演示"><AnchorLink to="#代码演示" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>代码演示</h3>
<p>简单使用：</p>
</div><Previewer {...DUMI_ALL_DEMOS['table-demo'].previewerProps}><DumiDemo1 /></Previewer>
<div className="markdown"><h3 id="api"><AnchorLink to="#api" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>API</h3>
<h5 id="table-1"><AnchorLink to="#table-1" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>Table</h5>































































































<table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>columns</td><td>列</td><td>ColumnType&lt; T &gt;[]</td><td>-</td></tr><tr><td>dataSource</td><td /><td>T[]</td><td>-</td></tr><tr><td>rowClassName</td><td /><td>string</td><td>-</td></tr><tr><td>renderNoData</td><td /><td>React.ReactNode</td><td>-</td></tr><tr><td>rowsPerPageOptions</td><td /><td>number[]</td><td>-</td></tr><tr><td>pagination</td><td /><td>{"{"} total: number; current: number; pageSize: number; {"}"}</td><td>-</td></tr><tr><td>hover</td><td /><td>boolean</td><td>-</td></tr><tr><td>loading</td><td /><td>boolean</td><td>-</td></tr><tr><td>classes</td><td /><td>Object</td><td>-</td></tr><tr><td>style</td><td /><td>React.CSSProperties</td><td>-</td></tr><tr><td>className</td><td /><td>string</td><td>-</td></tr><tr><td>onChange</td><td /><td>(newPage: number, newPageSize: number) =&gt; void</td><td>-</td></tr><tr><td>onRowClick</td><td /><td>(record: T, index: number) =&gt; void</td><td>-</td></tr><tr><td>onSort</td><td /><td>(key: string | number, sort: string) =&gt; void</td><td>-</td></tr></tbody></table>
<h5 id="columntype"><AnchorLink to="#columntype" aria-hidden="true" tabIndex={-1}><span className="icon icon-link" /></AnchorLink>ColumnType</h5>



























































<table><thead><tr><th>参数</th><th>说明</th><th>类型</th><th>默认值</th></tr></thead><tbody><tr><td>title</td><td /><td>string</td><td>-</td></tr><tr><td>dataIndex</td><td /><td>string</td><td>-</td></tr><tr><td>width</td><td /><td>string | number</td><td>-</td></tr><tr><td>key</td><td /><td>string</td><td>-</td></tr><tr><td>paddingRight</td><td /><td>string | number</td><td>-</td></tr><tr><td>sortable</td><td /><td>boolean</td><td>-</td></tr><tr><td>sortDirection</td><td /><td>asc | desc | ""</td><td>-</td></tr><tr><td>render</td><td /><td>(value: any, record: RecordType, index: number) =&gt; React.ReactNode</td><td>-</td></tr></tbody></table></div></React.Fragment>
        </>
      );
  }